import React, { useState } from 'react';
import { Modal, Button, Form, Image, ListGroup } from 'react-bootstrap';

const CreateGroupModal = ({ show, handleClose, handleSave }) => {
  const [groupData, setGroupData] = useState({
    bannerPicture: '',
    mainPicture: '',
    name: '',
    privacy: 'public',
    members: []
  });

  const [dummyUsers] = useState([
    { id: 1, name: 'John Doe', avatar: 'https://example.com/avatar1.jpg' },
    { id: 2, name: 'Jane Smith', avatar: 'https://example.com/avatar2.jpg' },
    { id: 3, name: 'Bob Johnson', avatar: 'https://example.com/avatar3.jpg' },
  ]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      const file = files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setGroupData(prevData => ({
          ...prevData,
          [name]: reader.result
        }));
      };
      if (file) {
        reader.readAsDataURL(file);
      }
    } else {
      setGroupData(prevData => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSave(groupData);
    handleClose();
  };

  const toggleMember = (userId) => {
    setGroupData(prevData => {
      const updatedMembers = prevData.members.includes(userId)
        ? prevData.members.filter(id => id !== userId)
        : [...prevData.members, userId];
      return { ...prevData, members: updatedMembers };
    });
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create New Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Banner Picture</Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                type="text"
                name="bannerPicture"
                value={groupData.bannerPicture}
                onChange={handleChange}
                placeholder="Enter banner picture URL"
                className="me-2"
              />
              <Form.Control
                type="file"
                name="bannerPicture"
                onChange={handleChange}
                accept="image/*"
              />
            </div>
            {groupData.bannerPicture && (
              <Image src={groupData.bannerPicture} fluid className="mt-2" alt="Banner Preview" />
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Main Picture</Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                type="text"
                name="mainPicture"
                value={groupData.mainPicture}
                onChange={handleChange}
                placeholder="Enter main picture URL"
                className="me-2"
              />
              <Form.Control
                type="file"
                name="mainPicture"
                onChange={handleChange}
                accept="image/*"
              />
            </div>
            {groupData.mainPicture && (
              <Image src={groupData.mainPicture} fluid className="mt-2" style={{ maxWidth: '150px' }} alt="Main Picture Preview" />
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Group Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={groupData.name}
              onChange={handleChange}
              placeholder="Enter group name"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Privacy</Form.Label>
            <Form.Check
              type="radio"
              label="Public"
              name="privacy"
              value="public"
              checked={groupData.privacy === 'public'}
              onChange={handleChange}
            />
            <Form.Check
              type="radio"
              label="Private"
              name="privacy"
              value="private"
              checked={groupData.privacy === 'private'}
              onChange={handleChange}
            />
          </Form.Group>
          {groupData.privacy === 'private' && (
            <Form.Group className="mb-3">
              <Form.Label>Add Members</Form.Label>
              <ListGroup>
                {dummyUsers.map(user => (
                  <ListGroup.Item key={user.id} className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <Image src={user.avatar} roundedCircle width="30" height="30" className="me-2" />
                      {user.name}
                    </div>
                    <Button
                      variant={groupData.members.includes(user.id) ? "danger" : "success"}
                      size="sm"
                      onClick={() => toggleMember(user.id)}
                    >
                      {groupData.members.includes(user.id) ? "Remove" : "Add"}
                    </Button>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Form.Group>
          )}
          <Button variant="primary" type="submit">
            Save Group
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateGroupModal;